import { Component, OnInit, ViewChild } from '@angular/core';
import {
  PermitService, PermitDetailsModel, PermitDetailsTransactionItemModel,
  TransactionDetailsResponseData
} from '../services/permit.service';
import { ErrorHandlingService, LocalParserFormatter, AuthorizeService } from 'core-lib';
import { ListComponentBase, ListViewModelBase, FilterBase } from 'core-lib';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment.prod';
import { LoggerLocationModalComponent } from '../modals/logger-location-modal/logger-location-modal.component';
import { PermitDetailsVehicleItemModel } from 'projects/admin-web/src/app/services/permit.service';
import { FileAttachmentDetailsModel } from '../components/file-upload/file-upload.component';

@Component({
  selector: 'cli-transactions-list',
  templateUrl: './transactions-list.component.html',
  styleUrls: ['./transactions-list.component.scss']
})
export class TransactionsListComponent extends ListComponentBase implements OnInit {

  public vm: TransactionListViewModel;
 public fullUrl: string;

  @ViewChild('transactionLocationModal')
  public transactionLocationModal: LoggerLocationModalComponent;

  constructor(private permitSvc: PermitService,
    private authSvc: AuthorizeService,
    private errorHandlingSvc: ErrorHandlingService,
    private formatter: LocalParserFormatter,
    private router: Router) {
    super();
    this.vm = new TransactionListViewModel();
  }


  ngOnInit() {
    this.vm.isLoading = true;
    this.vm.isOpening = !this.permitSvc.model;
    this.fullUrl = environment.downloadFileUrl + '/';
    this.permitSvc.getDetails().toPromise().then((data: PermitDetailsModel) => {

      this.mapModel(this.vm, data);
      this.wireUpSearchTextFilter();

    },
      (e) => {
        this.errorHandlingSvc.processHttpError(e);

      }).finally(()=>{
        this.vm.isLoading = false;
        this.vm.isOpening = false;
      });

  }

  public onChange(event: any): void {
    this.vm.filter.skip = 0;
    this.loadList();
  }

  mapModel(vm: TransactionListViewModel, data: PermitDetailsModel) {
    vm.businessName = data.permitDetails.clientName;
    vm.contactName = data.permitDetails.firstName + ' ' +  data.permitDetails.lastName;
    vm.permitNo = data.permitDetails.permitNo;

    vm.totalCount = data.transactionCount;
    vm.items = _.map(data.transactions, (t: PermitDetailsTransactionItemModel) => this.mapItem(t));
  }

  loadList(): Promise<void> {
    this.vm.isLoading = true;

    this.vm.filter.startDate = this.formatter.toIsoString(this.vm.filter.startDateValue);
    this.vm.filter.endDate = this.formatter.toIsoString(this.vm.filter.endDateValue);

    return this.permitSvc.getTransactions(this.vm.filter).toPromise()
      .then((data: TransactionDetailsResponseData) => {

        this.vm.totalCount = data.totalCount;
        this.vm.items = _.map(data.items, (b: PermitDetailsTransactionItemModel) => {
          return this.mapItem(b);
        });
      },
        (e) => {
          let errorMessage = this.errorHandlingSvc.processHttpError(e);
          return Promise.reject(errorMessage);
        }).finally(() => { this.vm.isLoading = false; });
  }

  mapItem(b: PermitDetailsTransactionItemModel): TransactionListDetailsViewModel {
    let bm = new TransactionListDetailsViewModel();

    if (b.transactionType === 'Logger' && (b.location || '') !== '' && (b.isOutOfBillableArea || b.isDoNotBill)) {
      bm.cost = 0;
    }
    else {
      bm.cost = b.cost;
    }
    bm.transactionId = b.transactionId;
    bm.fillDate = this.formatter.toDate(this.formatter.fromIsoString(b.fillDate));
    bm.regoNo = b.regoNo;
    bm.suburb = b.location;
    bm.cost = b.cost;
    bm.transactionType = this.mapTransactionType(b);
    bm.volume = b.volume;
    bm.status = b.status;
    bm.latitude = b.latitude;
    bm.longitude = b.longitude;
    bm.attachments = b.attachments;
    return bm;
  }

  mapTransactionType(t: PermitDetailsTransactionItemModel): string {
    if (!t.transactionType) { return ('n/a'); }
    if (t.transactionType.toUpperCase() === 'LOGGER') { return 'Device'; }
    if (t.transactionType.toUpperCase() === 'WATERUSAGE') { return 'Manual'; }
    if (t.transactionType.toUpperCase() === 'EMS') { return 'EMS'; }
    return 'n/a';
  }

  public addManual() {
    this.router.navigate(['/app/water-usage']);
  }

  public addManualBulk() {
    this.router.navigate(['/app/water-usage-bulk']);
  }

  public downloadCsv() {

    this.vm.filter.startDate = this.formatter.toIsoString(this.vm.filter.startDateValue);
    this.vm.filter.endDate = this.formatter.toIsoString(this.vm.filter.endDateValue);

    let queryString = '';
    let filter = this.vm.filter;
    let token = 'aaaa';
    let userId = this.authSvc.userId;

    if (filter) {
      queryString = queryString + '?searchText=' + (!filter.search ? '' : filter.search);
      queryString = queryString + '&permitNumber=' + (!filter.permitNo ? '' : filter.permitNo);
      queryString = queryString + '&transactionType=' + (!filter.transactionType ? '' : filter.transactionType);
      queryString = queryString + '&location=' + (!filter.location ? '' : filter.location);
      queryString = queryString + '&vehicleNumber=' + (!filter.regoNo ? '' : filter.regoNo);
      queryString = queryString + '&volume=' + (!filter.volume ? '' : filter.volume);
      queryString = queryString + '&startDate=' + (!filter.startDate ? '' : filter.startDate);
      queryString = queryString + '&endDate=' + (!filter.endDate ? '' : filter.endDate);
      queryString = queryString + '&orderBy=' + (!filter.orderBy ? '' : filter.orderBy);
      queryString = queryString + '&isDesc=' + (!filter.isDesc ? 'false' : filter.isDesc ? 'true' : 'false');
      queryString = queryString + '&skip=0';
      queryString = queryString + '&take=0';
      queryString = queryString + '&token=' + token;
      queryString = queryString + '&userId=' + userId;
    }

    this.vm.downloadUrl = environment.transactionDownloadUrl + queryString;

    window.open(this.vm.downloadUrl, '_self');
  }

  public openSearch() {
    this.vm.isSearchOpen = true;
  }

  public closeSearch() {

    this.vm.filter = new TransactionListFilter();
    this.vm.isSearchOpen = false;

    this.permitSvc.getDetails().toPromise().then((data: PermitDetailsModel) => {
      this.mapModel(this.vm, data);
    });
  }

  public clearSearch() {
    this.vm.filter = new TransactionListFilter();
  }

  public showOnMap(t: PermitDetailsTransactionItemModel){
    this.transactionLocationModal.header =  `Water Usage ${moment(t.fillDate).format('DD/MM/YYYY HH:mm')}`;
    this.transactionLocationModal.transaction = t;
    this.transactionLocationModal.openModal();
  }

  public editTransaction(t: PermitDetailsTransactionItemModel) {

    this.permitSvc.getDetails().toPromise().then((data: PermitDetailsModel) => {

      let v = _.find(data.vehicles, (n: PermitDetailsVehicleItemModel) => t.regoNo === n.rego);

      if (v.capacity === t.volume) {

        this.router.navigate(['/app/water-usage/' + t.transactionId]);
      }
      else
       {

          this.router.navigate(['/app/water-usage-bulk/' + t.transactionId]);
        }


    },
      (e) => {
        this.errorHandlingSvc.processHttpError(e);

      }).finally(() => {
        this.vm.isLoading = false;
        this.vm.isOpening = false;
      });





  }
}

export class TransactionListViewModel extends ListViewModelBase {
  constructor() {
    super();
    this.items = [];
    this.filter = new TransactionListFilter();
  }

  public isOpening: boolean;
  public isLoading: boolean;
  public isSearchOpen: boolean;
  public businessName: string;
  public contactName: string;
  public permitNo: string;

  public downloadUrl: string;
  public filter: TransactionListFilter;
  public items: TransactionListDetailsViewModel[];
}

export class TransactionListDetailsViewModel {
  public transactionId: string;
  public regoNo: string;
  public volume: number;
  public transactionType: string;
  public fillDate: Date;
  public cost: number;
  public latitude: number;
  public longitude: number;
  public suburb: string;
  public status: string;
  public attachments: FileAttachmentDetailsModel[];
}

export class TransactionListFilter extends FilterBase {

  constructor() {
    super();
    this.take = 20;
    this.skip = 0;
    this.regoNo = '';
    this.transactionType = '';
  }

  public permitNo: string;
  public regoNo: string;
  public volumeClause: string;
  public volume: string;
  public location: string;
  public transactionType: string;
  public startDate: string;
  public endDate: string;
  public startDateValue: any;
  public endDateValue: any;
}
